import type { SearchFilesParamsEntryType } from "@/api/files";
import type { Item } from "@/types/fse";

interface VisibleEntryTypes {
  showFiles: boolean;
  showFolders: boolean;
}

export const getSearchEntryTypes = ({
  showFiles,
  showFolders,
}: VisibleEntryTypes): SearchFilesParamsEntryType[] | undefined => {
  if (showFiles && showFolders) {
    return undefined;
  }

  const entryTypes: SearchFilesParamsEntryType[] = [];
  if (showFiles) entryTypes.push("file");
  if (showFolders) entryTypes.push("folder");

  return entryTypes;
};

export const isItemInFolderTree = (item: Item, folderId?: string): boolean => {
  if (!folderId) return false;
  if (item.id === folderId) return true;

  return item.locations.some(location => location.path.some(pathItem => pathItem.id === folderId));
};

export const shouldShowItem = (
  item: Item,
  {
    showFiles,
    showFolders,
    filterCurrentFolder,
  }: VisibleEntryTypes & {
    filterCurrentFolder?: string;
  },
): boolean => {
  if (item.type === "file" && !showFiles) return false;
  if (item.type === "folder" && !showFolders) return false;

  return !isItemInFolderTree(item, filterCurrentFolder);
};
